import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=23497356&scoped=true"
import script from "./SubTitle.vue?vue&type=script&lang=js"
export * from "./SubTitle.vue?vue&type=script&lang=js"
import style0 from "./SubTitle.vue?vue&type=style&index=0&id=23497356&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23497356",
  null
  
)

export default component.exports